export const config = {
  thresholds: {
    abbreviatedAttributes: 20,
    display: {
      // Display by SKU if <= 5 Product IDs
      bySKU: 5,
      byID: 6
    }
  },
  classes: {
    attributes: 'tree-ul js',
    container: 'refinement-content js',
    title: 'js'
  },
  selectors: {
    id: {
      groups: 'attribute-groups',
      activeAttributeCountMobile: 'mobile-refinement-button'
    }
  }
}